$(document).ready(function() { 
    $('nav.header__inline-menu li a[href^="#"]').click(function(event) {
        
        var id = $(this).attr("href");
        var offset = 20;
        var target = $(id).offset().top - offset;
        $('html, body').animate({scrollTop:target}, 1500);
        event.preventDefault();
    });
    $('header.header a.menu-drawer__menu-item[href^="#"]').click(function(event) {
        
        var id = $(this).attr("href");
        var offset = 20;
        var target = $(id).offset().top - offset;
        $('html, body').animate({scrollTop:target}, 1500);
        event.preventDefault();
    });
   /* $('header.header .menu-drawer__menu-item').click(function(event) {
       $('summary.header__icon').trigger('click');
    });*/
    $('ul.menu-drawer__menu.has-submenu.list-menu li a').click(function(event) {
       $('summary.header__icon').trigger('click');
    }); 
    $( ".footer-copy p:contains('Accessibility ')").click(function(){
      $(".accessibly-otm-widget-button").trigger("click");
      $(".acsb-trigger").trigger("click");
    });
    $( ".footer-copy p:contains('Accessibility')").click(function(){
      $(".accessibly-otm-widget-button").trigger("click");
      $(".acsb-trigger").trigger("click")
    });
    $( ".footer-copy p:contains('accessibility')").click(function(){
      $(".accessibly-otm-widget-button").trigger("click");
      $(".acsb-trigger").trigger("click")
    });
});


$(document).ready(function(){
  
  $(".rq-product-slider-new").slick({
    //autoplay:true,
    slidesToShow:1,
    slidesToScroll:1,
    dots:false,
    draggable:true, 
    arrows : false,
    adaptiveHeight: true,
    fade:true,
    //fade:true,
    asNavFor: '.rq-thumbnail-slider',
    //prevArrow: false,
    //nextArrow: false,
    
    infinite:false,
    
    //prevArrow:'<button class="rq-PrevArrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="40.4" y="41.4" class="st0" width="43.2" height="40.3"/><path d="M95.8,61.2c0-19.2-15.7-34.8-35.1-34.8c-19.4,0-35.1,15.6-35.1,34.8c0,19.2,15.7,34.8,35.1,34.8	C80.1,95.9,95.8,80.4,95.8,61.2z M53.7,61.2l11.6-11.4l1.7,1.7l-9.8,9.7L67,71.3L65.2,73L53.7,61.2z"/></svg></button>',
    //nextArrow:'<button class="rq-NextArrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122"  xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="39.4" y="40.8" class="st0" width="43.2" height="40.3"/><path d="M27.2,60.8c0,19.2,15.7,34.8,35.1,34.8c19.4,0,35.1-15.6,35.1-34.8c0-19.2-15.7-34.8-35.1-34.8 C42.9,26.1,27.2,41.6,27.2,60.8z M69.3,60.8L57.8,72.3L56,70.5l9.8-9.7L56,50.7l1.8-1.7L69.3,60.8z"/></svg></button>', 
    //nextArrow: $('.gb-main-product-arrows .carousel-next'), 
    //prevArrow:  $('.gb-main-product-arrows .carousel-prev'),
    //responsive: [
    //{
    //  breakpoint: 767,
    //  settings: {
    //  slidesToShow:2,
    //  }
   // }
   //]
 });
  //$('.gb-main-product-arrows .carousel-prev').click(function(){ 
	//	$(this).parent().parent().find('.carousel-gb').slick('slickPrev');
  //});
	
  //$('.gb-main-product-arrows .carousel-next').click(function(e){
		//e.preventDefault(); 
		//$(this).parent().parent().find('.carousel-gb').slick('slickNext');
  //});
    
   $('.rq-thumbnail-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true, 
    //centerMode: true, 
    adaptiveHeight: true, 

    
    vertical:true, //vertical
    verticalSwiping:true,  //vertical

     
    infinite:false, 
    //centerPadding: "25%", 
    asNavFor: '.rq-product-slider-new', 
    prevArrow: '<button class="rq-PrevArrow-thumb slick-prev slick-arrow"" type="button" data-role="none"  aria-label="Previous" role="button" aria-disabled="true"><svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve"><defs></defs><g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"><path d="M 58.799 58.33 L 16.466 15.998 c -1.059 -1.059 -2.776 -1.059 -3.835 0 L 0.794 27.834 c -1.059 1.059 -1.059 2.776 0 3.835 l 42.333 42.333 c 1.059 1.059 2.776 1.059 3.835 0 l 11.837 -11.837 C 59.858 61.107 59.858 59.39 58.799 58.33 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path><path d="M 31.201 58.33 l 42.333 -42.333 c 1.059 -1.059 2.776 -1.059 3.835 0 l 11.837 11.837 c 1.059 1.059 1.059 2.776 0 3.835 L 46.873 74.002 c -1.059 1.059 -2.776 1.059 -3.835 0 L 31.201 62.166 C 30.142 61.107 30.142 59.39 31.201 58.33 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path></g></svg></button>',
    nextArrow: '<button class="rq-NextArrow-thumb slick-next slick-arrow" type="button" data-role="none"  aria-label="Next" role="button" style="" aria-disabled="false"><svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve"><defs></defs><g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"><path d="M 58.799 58.33 L 16.466 15.998 c -1.059 -1.059 -2.776 -1.059 -3.835 0 L 0.794 27.834 c -1.059 1.059 -1.059 2.776 0 3.835 l 42.333 42.333 c 1.059 1.059 2.776 1.059 3.835 0 l 11.837 -11.837 C 59.858 61.107 59.858 59.39 58.799 58.33 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path><path d="M 31.201 58.33 l 42.333 -42.333 c 1.059 -1.059 2.776 -1.059 3.835 0 l 11.837 11.837 c 1.059 1.059 1.059 2.776 0 3.835 L 46.873 74.002 c -1.059 1.059 -2.776 1.059 -3.835 0 L 31.201 62.166 C 30.142 61.107 30.142 59.39 31.201 58.33 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path></g></svg></button>',
    responsive: [
    {
        breakpoint: 1023,
        settings: {
          vertical: false,
        }
    }
    ]  
     
  });
    
  
  $('.rq-thumbnail-slider a.thumb.slick-slide').click(function(e) {
   e.preventDefault();
    var slideno = $(this).attr('data-slick-index');
    $('.rq-product-slider-new').slick('slickGoTo', slideno);
  });

});

$( document ).ready(function() {
  // var filtered = false;
 $(".vb-options-set").on("click", function() { 
   $('.rq-thumbnail-slider').slick('slickUnfilter');
  var valuegb = $(this).attr('alt').toLowerCase();
   console.log(valuegb);
  var slide_no =   $('.rq-common-filter[rq-get-img-first-alt-tag="'+valuegb+'"]').attr('data-slick-index');
  var get_filter_slide =   $('.rq-common-filter[rq-get-img-first-alt-tag="'+valuegb+'"]');

 
  $('.rq-thumbnail-slider').slick('slickFilter' , get_filter_slide);
  $('.rq-product-slider-new').slick('slickGoTo', slide_no);
   
 /* if (filtered === false) {
    $('.rq-thumbnail-slider').slick('slickFilter' , gb);
    $(this).text('Unfilter Slides');
    filtered = true;
  } else {
    $('.rq-thumbnail-slider').slick('slickUnfilter');
    $(this).text('Filter Slides');
    filtered = false;
  }*/
   /*var trimStr_val = $.trim(valuegb);
  $('.rq-common-filter').filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(trimStr_val) > -1);
  });*/   
   
  
   
 });
  
});  


$(document).ready(function() { 
    $('nav.header__inline-menu li a').click(function(event) {
       $('nav.header__inline-menu li a').removeClass('active-bg');
       $(this).addClass('active-bg');
    });  
    var url = window.location.href; 
    var get_active = url.split("#");
    var get_link = '#'+get_active[1];
    $("nav.header__inline-menu li a[href*='"+get_link+"']").addClass("active-bg");
    //console.log("a[href*="+get_link+"]");
});        
/*$(document).ready(function(){

    // Select and loop the container element of the elements you want to equalise
    $('.product-grid-gallery').each(function(){  
      
      // Cache the highest
      var highestBox = 0;
      
      // Select and loop the elements you want to equalise
      $('.sameheight', this).each(function(){
        
        // If this box is higher than the cached highest then store it
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
            
      // Set the height of all those children to whichever was highest 
      $('.sameheight',this).height(highestBox);
                    
    }); 

});*/

$( document ).ready(function() {
  //$(".go-to-fil").click(function(){
  $('body').on('change', '.select-btn-recipes-two', function(){ 
    var getlink = $(this).val();
    $("#get-main-blog-append").load(getlink+" #get-main-blog-append");
  });
});

$(document).ready(function() {
  var url  = window.location.href; 
  var get_cat = url.split("?");
  if (get_cat.length > 1) {
    var get_cat_final = get_cat[1].toLowerCase();
    var get_cat_final_sanitized = get_cat_final.replace(/[^a-z0-9-_]/g, ''); // Sanitize to allow only alphanumeric, dash, and underscore
    var get_cat_link = $(".select-btn-recipes-two option[get_direct_link='"+get_cat_final_sanitized+"']").val();
    $(".select-btn-recipes-two").val(get_cat_link).change(); // Change the selected option and trigger the change event
    $("#get-main-blog-append").load(get_cat_link+" #get-main-blog-append");
  }
});



$( document ).ready(function() {
 var get_click_value =   $('.vg-color-onlycolor .vb-checked-value:checked').val().toLowerCase();
 $("li.thumbnail-list__item.slider__slide").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(get_click_value) > -1);
  });  
  $(".vblist-padding-media").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(get_click_value) > -1);
  }); 
 $(".vg-color-onlycolor .vb-click-for-radio").on("click", function() { 
    var get_click_value = $(this).attr('value').toLowerCase();
     
    $("li.thumbnail-list__item.slider__slide").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(get_click_value) > -1);
    });
    $(".vblist-padding-media").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(get_click_value) > -1);
    });
 });
});  


/*VB! megamenu STARTS*/
$(document).ready(function(){
   $( ".gs-add-click" ).hover(
      function() { 
         $(this).closest('.HorizontalList__Item').find('.MegaMenu').attr('aria-hidden', 'false');
      }, function() {
        $(this).closest('.HorizontalList__Item').find('.MegaMenu').attr('aria-hidden', 'true');
      }
   );
    $( ".MegaMenu" ).hover(
      function() { 
         $(this).closest('.HorizontalList__Item').find('.MegaMenu').attr('aria-hidden', 'false');
      }, function() {
        $(this).closest('.HorizontalList__Item').find('.MegaMenu').attr('aria-hidden', 'true');
      }
   );
   
  $('body').on('click', '.vb-click-open-megamenu', function(){  
     var get_val =  $(this).closest('.HorizontalList__Item').find('.MegaMenu').attr('aria-hidden');
     if(get_val == "true") {
          $(this).closest('.HorizontalList__Item').find('.MegaMenu').attr('aria-hidden', 'false');
         $(this).closest('.HorizontalList__Item').find('.MegaMenu').addClass('vb-rotate');
       }else{  
           $(this).closest('.HorizontalList__Item').find('.MegaMenu').attr('aria-hidden', 'true');
           $(this).closest('.HorizontalList__Item').find('.MegaMenu').removeClass('vb-rotate');
       }
       
  });  

  $('body').on('click', '.vb-common-click', function(){  
    $('cart-drawer.drawer').addClass('active');
  });  

     setTimeout(function () { 
       $("iframe").contents().find('.formFooter.f6.branding21').hide();
       $("iframe").contents().find('.formFooter-heightMask').hide();
       $("iframe").contents().find('.thankyou-footer-wrapper').hide();
     }, 2500);   
 
});
/*VB! megamenu ENDS*/